import { Button, IconButton, Text } from "@mbank-design/design-system/components";
import CustomIllustration from "../../../assets/images/256x256_popup_v2-removebg.png"
import "./index.scss";
import { Cross } from "@mbank-design/design-system/icons";
import { IconButtonIconSize, IconButtonType } from "@mbank-design/design-system/enums";
import { useEffect, useState } from "react";
import { useMobileOnlyMedia } from "@mbank-design/design-system/components/Media/useMobileOnlyMedia";

export const BottomPromoBanner = ({ handleBottomPromoBannerClose }: { handleBottomPromoBannerClose: () => void }) => {

    const [isOpen, setIsOpen] = useState(false);

    const isMobile = useMobileOnlyMedia()
    useEffect(() => {
        const checkSessionStorage = sessionStorage.getItem("bottomPromoBanner");
        if (checkSessionStorage) {
            setIsOpen(false);
        } else {
            setIsOpen(true);
        }
    }, []);

    const handleClose = () => {
        setIsOpen(false);
        handleBottomPromoBannerClose();
        sessionStorage.setItem("bottomPromoBanner", "true");
    };
    return (
        <>
            {isOpen && (
                <div className="bottom-promo-banner">
                    <div className="bottom-promo-banner__content">
                        <div className="bottom-promo-banner__text">
                            <Text as={"h5"} >
                            kieruj się zyskiem
                            </Text>
                            <Text as={"p"}>
                                odbierz 2000 zł na leasing z kontem firmowym w mBanku
                            </Text>
                        <img src={CustomIllustration} alt="Promo Banner" className="bottom-promo-banner__image" />
                        </div>
                        <div className="bottom-promo-banner__action"><a href="/lp-taniej-z-mb"><Button buttonType="primary" className="bottom-promo-banner__action__button">sprawdź</Button></a>
                            <IconButton iconComponent={Cross} buttonType={IconButtonType.TRANSPARENT} onClick={handleClose} iconSize={IconButtonIconSize.SIZE_24} />
                        </div>
                        <a href="/lp-taniej-z-mb" className="bottom-promo-banner__button--mobile">
                            <Button buttonType="primary" isFullWidth >sprawdź</Button>
                        </a>
                    </div>
                </div>
            )}
        </>
    );
};